import { inject } from '@angular/core';
import { ApiService } from '@libs/core/base-config';
import { NgEventBus } from '@libs/core/lib/event-bus/ng-event-bus';
import { asResult, dataFromState } from '@libs/core/lib/state/async-states';
import { withWalletTransactionsList } from '@libs/mtjr/shared/generated/entities/wallet-transaction/wallet-transaction-store-features';
import { getUserWallet } from '@libs/mtjr/shared/generated/entities/wallet/service/wallet.service';
import { withGetUserWallet } from '@libs/mtjr/shared/generated/entities/wallet/wallet-store-features';
import { patchState, signalStore, withComputed, withHooks, withMethods } from '@ngrx/signals';
import Decimal from 'decimal.js';

export const WalletStore = signalStore(
  { providedIn: 'root' },
  withGetUserWallet(),
  withWalletTransactionsList(),
  withComputed((store) => ({
    walletBalance: dataFromState(store.getUserWalletState, (state) => state?.balance || new Decimal(0)),
    heldBalance: dataFromState(store.getUserWalletState, (state) => state?.holdBalance || new Decimal(0)),
  })),
  withMethods((store, apiService = inject(ApiService)) => ({
    // fetches balance without trigger loading state
    async refreshBalance() {
      const result = await asResult(getUserWallet(apiService, { userId: '000000000000000000000000' }));
      patchState(store, { getUserWalletState: result });
    },

    async loadBalanceIfNeeded() {
      if (!store.getUserWalletState().success) {
        return store.getUserWallet({ userId: '000000000000000000000000' });
      }
    },
  })),

  withHooks((store, eventBus = inject(NgEventBus)) => ({
    onInit() {
      eventBus.on('wallet:fetch').subscribe(() => {
        store.refreshBalance();
        store.walletTransactionsListPage({ page: 1 });
      });
    },
  })),
);
